import styled from 'styled-components'
import { COLORS } from '../../styles/theme'
import config from '../../config'

export const StyledLandingPage = styled.div`
  .smithNephew {
    display: flex;
    position: fixed;
    flex-direction: column;
    justify-content: center;
    top: 18%;
    bottom: 11%;
    left: 14%;
    right: 66.5%;
    cursor: pointer;
    :hover {
      animation: heartbeat 7s infinite;
    }
    .logo-container {
      display: flex;
      justify-content: center;
      img {
        width: 50%;
      }
    }
  }

  .malex-1 {
    display: flex;
    position: fixed;
    flex-direction: column;
    justify-content: center;
    top: 19%;
    bottom: 11%;
    left: 41%;
    right: 39%;
    cursor: pointer;
    :hover {
      animation: heartbeat 7s infinite;
    }
    .logo-container {
      display: flex;
      justify-content: center;
      img {
        width: 50%;
      }
    }
  }

  .malex-2 {
    display: flex;
    position: fixed;
    flex-direction: column;
    justify-content: center;
    top: 19%;
    bottom: 11%;
    left: 66.5%;
    right: 13.5%;
    cursor: pointer;
    :hover {
      animation: heartbeat 7s infinite;
    }
    /* border: 1px solid red; */
    .logo-container {
      display: flex;
      justify-content: center;
      img {
        width: 50%;
      }
    }
  }
`

export const StyledTheatre = styled.div`
  .side-tv-container {
    .left-container-sn {
      position: fixed;
      top: 28%;
      left: 13.6%;
      bottom: 66%;
      right: 78%;
  }
      img {
        width: 100%;
      }
    }

    .right-container-sn {
      position: fixed;
      top: 28%;
      left: 78%;
      bottom: 66%;
      right: 13.8%;
      img {
        width: 100%;
      }
    }

    .left-container-ml {
      position: fixed;
      top: 26%;
      left: 15%;
      bottom: 66%;
      right: 79%;
      img {
        width: 100%;
      }
    }

    .right-container-ml {
      position: fixed;
      top: 26%;
      left: 79.4%;
      bottom: 66%;
      right: 14.8%;
      img {
        width: 100%;
      }
    }
  }
  .center-tv-container {
    position: absolute;
    /* border: 1px solid red; */
    top: 4%;
    left: 15%;
    right: 15%;
    bottom: 57.5%;
    img {
      width: 53%;
    }
    iframe {
      height: 100%;
      width: 100%;
    }
  }

  .return-button {
    position: absolute;
    bottom: 5%;
    text-decoration: none;
    background: linear-gradient(#ff9821, #f65148, #f22f5b);
    color: ${COLORS.hotButtonText};
    border-radius: 32px;
    border: 2px solid #ff9821;
    padding: 8px 16px;
    text-align: center;
    box-shadow: 0px 5px 4px -4px #000;
    left: 8%;
    cursor: pointer;
    p {
      margin: 0 auto;
    }
  }
`
